import { useWallet } from '../hooks/useWallet'

export default function WalletConnectPrompt() {
  const { connect, isConnecting } = useWallet()

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="card max-w-md w-full text-center">
        <div className="w-20 h-20 bg-geo-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-geo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">Connect Your Wallet</h2>
        <p className="text-gray-500 mb-6">
          Connect your Freighter wallet to discover quests nearby and earn GEO rewards for visiting eco-friendly locations.
        </p>
        <button onClick={connect} disabled={isConnecting} className="btn-primary w-full">
          {isConnecting ? 'Connecting...' : 'Connect Freighter'}
        </button>
        <p className="text-xs text-gray-400 mt-4">
          Don't have Freighter?{' '}
          <a href="https://www.freighter.app/" target="_blank" rel="noopener noreferrer" className="text-geo-600 hover:underline">
            Install it here
          </a>
        </p>
      </div>
    </div>
  )
}
